import { createAsyncThunk } from '@reduxjs/toolkit'
import { getDatabase, ref, update } from 'firebase/database'
import { OrderColorEnum } from '../../../constants/colors'
import { getFirebaseOrderColorsPath } from '../../../utils/getFirebaseOrderColorsPath'
import { RootState } from '../../store'

interface SetOrderColorPayload {
    orderKey: string
    color: OrderColorEnum
}

export const setOrderColor = createAsyncThunk<void, SetOrderColorPayload, { state: RootState }>(
    'order/setOrderColor',
    (payload, { getState }) => {
        const { license } = getState()

        if (!license) {
            throw new Error('license must be present in redux')
        }

        const db = getDatabase()

        update(ref(db, getFirebaseOrderColorsPath(license.token)), {
            [payload.orderKey]: payload.color,
        })
    }
)
